import React from "react";

export default function RGPD() {
  return (
    <div className="container-x py-16 max-w-3xl mx-auto text-sm leading-relaxed" data-testid="rgpd-page">
      <p className="overline text-[#2B8B8E] mb-2">Confidentialité</p>
      <h1 className="text-4xl font-light mb-8">Politique de confidentialité (RGPD)</h1>
      <p className="text-xs text-muted-foreground mb-6">Dernière mise à jour : février 2026</p>

      <h2 className="text-xl font-semibold mt-8 mb-3">1. Responsable de traitement</h2>
      <p>Synergie Workspace — Association loi 1901, Vauvert 30600, Gard. Contact : synergieworkspace@gmail.com.</p>

      <h2 className="text-xl font-semibold mt-8 mb-3">2. Données collectées</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li>Nom, prénom, adresse email (compte + réservations)</li>
        <li>Informations de réservation (espace, dates, créneaux)</li>
        <li>Données de paiement (traitées par Stripe — non stockées chez nous)</li>
        <li>Données Google (nom, email, photo) si connexion via Google Auth</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-3">3. Finalités</h2>
      <p>Gestion des comptes clients, réservations, facturation, communication liée aux réservations. Aucune revente à des tiers.</p>

      <h2 className="text-xl font-semibold mt-8 mb-3">4. Base légale</h2>
      <p>Exécution du contrat (réservations) et intérêt légitime (sécurité, prévention de la fraude).</p>

      <h2 className="text-xl font-semibold mt-8 mb-3">5. Durée de conservation</h2>
      <p>Comptes clients : 3 ans après dernière activité. Factures : 10 ans (obligation légale).</p>

      <h2 className="text-xl font-semibold mt-8 mb-3">6. Sous-traitants</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li>Stripe (paiement) — États-Unis, conforme RGPD</li>
        <li>Google (authentification optionnelle)</li>
        <li>MongoDB Atlas (hébergement base de données)</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-3">7. Vos droits</h2>
      <p>Vous disposez d'un droit d'accès, de rectification, d'effacement, de portabilité et d'opposition. Pour exercer ces droits : synergieworkspace@gmail.com.</p>

      <h2 className="text-xl font-semibold mt-8 mb-3">8. Cookies</h2>
      <p>Nous utilisons uniquement des cookies techniques nécessaires au fonctionnement du site (session, authentification). Aucun cookie de tracking ou publicitaire.</p>

      <h2 className="text-xl font-semibold mt-8 mb-3">9. Réclamation</h2>
      <p>Vous pouvez déposer une réclamation auprès de la CNIL : www.cnil.fr.</p>

      <p className="mt-10 p-4 bg-[#E0B66A]/10 border border-[#E0B66A]/30 rounded-lg text-xs">
        ⚠️ Ce document est un modèle générique. Nous recommandons de le faire valider par un DPO ou un juriste avant mise en production.
      </p>
    </div>
  );
}
